import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { scrollToTop } from 'utils';

import { CANT_FIND_BANK_MODAL_ID } from './constants';

import { useStatusDepositContext } from '../../../context';

export interface CantFindBankModalHook {
  onClick: () => void;
  disabled: boolean;
  isSubmitting: boolean;
}

export default function useCantFindBankModal(): CantFindBankModalHook {
  const { job, isSubmitting, togglePaymentMethod } = useStatusDepositContext();

  const { hideModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(() => {
    const id = job?.id;
    if (!id) return;
    togglePaymentMethod('card', () => {
      hideModal(CANT_FIND_BANK_MODAL_ID);
      scrollToTop();
    });
  }, [job, togglePaymentMethod, hideModal]);

  return {
    onClick,
    disabled: !job || isSubmitting,
    isSubmitting,
  };
}
